
const $d8b78096f4a87727$export$61980b37ccb54ba2 = (target)=>{
    if (target) {
        $d8b78096f4a87727$var$initialize(target);
        window.addEventListener("online", function(e) {
            $d8b78096f4a87727$var$setOnline(target);
        });
        window.addEventListener("offline", function(e) {
            $d8b78096f4a87727$var$setOffiline(target);
        });
    }
};
function $d8b78096f4a87727$var$initialize(connectionIndicatorElement) {
    if (navigator.onLine) $d8b78096f4a87727$var$setOnline(connectionIndicatorElement);
    else $d8b78096f4a87727$var$setOffiline(connectionIndicatorElement, "Offline. Loaded from cache");
}
function $d8b78096f4a87727$var$setOnline(connectionIndicatorElement, message = "You are online") {
    $d8b78096f4a87727$var$setOnlineClass(connectionIndicatorElement);
    $d8b78096f4a87727$var$setConnectionIndicatorText(connectionIndicatorElement, message);
}
function $d8b78096f4a87727$var$setOffiline(connectionIndicatorElement, message = "You have gone offline") {
    $d8b78096f4a87727$var$setOfflineClass(connectionIndicatorElement);
    $d8b78096f4a87727$var$setConnectionIndicatorText(connectionIndicatorElement, message);
}
function $d8b78096f4a87727$var$setOnlineClass(element) {
    if (element) {
        element.classList.add("online");
        element.classList.remove("offline");
        let icon = element.querySelector("i");
        if (icon) {
            icon.classList.add("icon-cloud");
            icon.classList.remove("icon-cloud-flash");
        }
    }
}
function $d8b78096f4a87727$var$setOfflineClass(element) {
    if (element) {
        element.classList.add("offline");
        element.classList.remove("online");
        let icon = element.querySelector("i");
        if (icon) {
            icon.classList.add("icon-cloud-flash");
            icon.classList.remove("icon-cloud");
        }
    }
}
function $d8b78096f4a87727$var$setConnectionIndicatorText(element, text) {
    if (element) {
        const textContainer = element.querySelector("span");
        // @ts-ignore
        textContainer.textContent = text;
    }
}


function $333062b585e05f44$export$bd949faeeb9baac9(selector) {
    const element = document.querySelector(selector);
    if (element) element.textContent = `2018 - ${new Date().getFullYear()}`;
}


(0, $333062b585e05f44$export$bd949faeeb9baac9)("footer > section#year");
const $295d08103c698a2a$var$offlineElement = document.getElementById("connection-status");
if ($295d08103c698a2a$var$offlineElement) (0, $d8b78096f4a87727$export$61980b37ccb54ba2)($295d08103c698a2a$var$offlineElement);


//# sourceMappingURL=index.920cdafd.js.map
